<template>
  <v-card elevation="0" outlined class=" pa-5" tile>
    <v-card-title>
      <v-icon color="grey darken-2">mdi-map-marker</v-icon>
      <div class="subtitle-1 font-weight-medium pl-2">Site Address:</div>
      <div class="subtitle-1 pl-2 font-weight-medium blue--text text--darken-2">
        {{ site.address }}
      </div>
      <v-spacer></v-spacer>
      <div class="subtitle-1 font-weight-medium ">Status:</div>
      <div class="subtitle-1 pr-2 pl-1">{{ siteStatus.text }}</div>
      <v-icon class="pr-2" :color="siteStatus.color" size="48">
        {{ siteStatus.icon }}
      </v-icon>
    </v-card-title>
    <v-row>
      <v-col cols="10" class="pl-5 ml-5" sm="6" md="4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field
            v-model="site.CTSN"
            :rules="ctsnRules"
            counter="9"
            label="Community Title Scheme Number"
            persistent-hint
            hint="The Community Title Scheme Number is required"
            required
            :mask="mask"
            maxlength="9"
            @input="input()"
            type="number"
            :disabled="disabled"
          ></v-text-field>
          <v-text-field
                  v-model="site.alternate"

                  label="Alternate Address for Site Inspection"
                  persistent-hint
                  hint="Optional"
                  :disabled="disabled"
          ></v-text-field>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="10" sm="6" md="4" class="pl-5 ml-5">
        <v-menu
          v-model="menuFrom"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="site.start"
              label="Start Date"
              prepend-icon="mdi-calendar-range"
              persistent-hint
              hint="Provide a start date for the inspection schedule (optional)"
              v-on="on"
              readonly
              :disabled="disabled"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="site.start"
            @input="menuFrom = false"
            :disabled="disabled"
            :min="new Date().toISOString()"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="10" sm="6" md="4" class="pl-5 ml-5">
        <v-menu
          v-model="menuTo"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="site.end"
              label="End Date or Insurance Renewal Date"
              prepend-icon="mdi-calendar-range"
              persistent-hint
              hint="Provide an end date for the inspection schedule (optional)"
              v-on="on"
              readonly
              :disabled="disabled"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="site.end"
            @input="menuTo = false"
            :disabled="disabled"
            :min="site.start"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="pa-5 ">
      <v-btn rounded color="primary" class="ma-2" @click="deleteSite" :disabled="disabled">
        <v-icon class="pr-2">mdi-delete</v-icon>
        Delete
      </v-btn>

      <v-dialog
        v-model="buildingDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
          <v-btn rounded color="primary" class="ma-2" v-on="on" :outlined="disabled">
            <v-icon class="pr-2">mdi-plus-circle</v-icon>
            Add Buildings
          </v-btn>
        </template>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Add Buildings to Your Site</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="buildingDialog = false">Done</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <Add :site="site"></Add>
      </v-dialog>
      <v-dialog
        v-model="siteDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn rounded color="primary" class="ma-2" v-on="on" :outlined="disabled">
            <v-icon class="pr-2">mdi-plus-circle</v-icon>
            Add Site Details
          </v-btn>
        </template>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Details About Your Site</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="siteDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <Details :site="site"></Details>
      </v-dialog>
      <v-btn
        rounded
        color="primary"
        class="ma-2"
        :disabled="disabled"
        @click="save"
        >
        <v-icon class="pr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
      <v-btn rounded color="teal lighten-1"  class="ma-2 white--text"
             @click="validate" :disabled="!valid || disabled">
        <v-icon class="pr-2">mdi-cloud-upload</v-icon>
        Submit for Inspection
      </v-btn>
      <v-btn rounded color="success" class="ma-2" :disabled="!report">
        <v-icon class="pr-2">mdi-file-download</v-icon>
        Report
      </v-btn>
    </v-row>
    <!-- Snackbar -->
    <v-snackbar v-model="alert.message" top left :timeout="timeout">
      {{alert.type}}
    </v-snackbar>
  </v-card>
</template>

<script>
import { router } from "../router";
import Details from "./Details.vue";
import Add from "./Add.vue";
import { status } from "../helpers";

export default {
  name: "Site",
  props: ["site"],
  components: {
    Details,
    Add
  },
  data: () => ({
    timeout: 6000,
    report: false,
    disabled: false,
    status: status,
    siteDialog: false,
    buildingDialog: false,
    mask: "#########",
    valid: false,
    changed: false,
    dateFrom: "",
    dateTo: "",
    menuFrom: false,
    menuTo: false,
    ctsnRules: [
      v => !!v || "CTSN is required",
      v => (v && v.length <= 9) || "CTSN must be less than 10 characters"
    ]
  }),
  computed:{
    alert (){
      return this.$store.state.alert
    },
    siteStatus (){
      return status[this.site.inspection_status.toString()]
    }
  },
  mounted() {
    if (this.site.inspection_status.toString() !== "P" ){
      this.disabled = true;
    }
  },
  methods: {
    input: function() {
      this.changed = true;
    },
    validate() {
      if (this.$refs.form.validate()) {

        this.submit();
      }
    },
    submit() {
      const site = this.site;
      this.$store.dispatch("sites/submitSite", { site } )
      .then(response => {
        if (this.site.inspection_status.toString() !== "P" ){
          this.disabled = true;
        }
      }, error => {

      });
    },
    save() {
      //TODO put in conditions of success here

      const site = this.site;
      this.$store.dispatch("sites/saveSite", { site } );
    },
    deleteSite(){
      const siteId = this.site.id;
      this.$store.dispatch("sites/delete", { site: siteId} );
    }
  }
};
</script>
